import { Typography } from '@mui/material'
import { InsightItem } from 'components/core/insights'
import { AccountOutcome, Outcome } from 'pbts/c1/api/analysis/v1/analysis'
import { InsightType } from 'pbts/c1/api/task/v1/insights'
import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'

export type GrantsAccountLabelProps = {
    outcome: Outcome | undefined
}

export const GrantsAccountLabel: FC<GrantsAccountLabelProps> = ({ outcome }) => {
    if (!outcome?.outcome) {
        return null
    }
    const grantsAccount = outcome.outcome as unknown as AccountOutcome
    return (
        <Typography>
            <FormattedMessage
                id="analysis_insights_grants_account"
                defaultMessage="{pop_with_access} out of {num_in_pop} accounts in this application have this entitlement"
                values={{
                    pop_with_access: grantsAccount.popWithAccess,
                    num_in_pop: grantsAccount.numInPop,
                }}
            />
        </Typography>
    )
}

export type GrantsAccountProps = {
    outcome: Outcome | undefined
    insightType: InsightType
    showIcon?: boolean
}

export const GrantsAccount: FC<GrantsAccountProps> = ({ outcome, insightType, showIcon = true }) => {
    if (!outcome?.outcome) {
        return null
    }
    if (!showIcon) {
        return <GrantsAccountLabel outcome={outcome} />
    }
    return (
        <InsightItem key="grants_account_item" insightType={insightType}>
            <GrantsAccountLabel outcome={outcome} />
        </InsightItem>

    )
}
